import { useState } from 'react';
import {
    HeaderWrapper,
    RequestDemoButton,
    LogoWrapper,
    ContentWrapper,
    TitleText,
    TextWrapper,
    BannerWrapper,
    Container,
} from './styles';
import Image from 'next/image';
import dynamic from 'next/dynamic';
import { getImageBasePath } from '@utils/generics';
import { AckoLogoConfig } from '@utils/constants';

interface IProps {
    isMobile: boolean;
}

const RequestDemoModal = dynamic(() => import('../requestModal'));

const Header = ({ isMobile }: IProps) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const onClick = () => {
        window.location.href = '/';
    };

    return (
        <HeaderWrapper>
            <Container>
                <LogoWrapper>
                    <Image
                        width={!isMobile ? '82px' : '63px'}
                        height={!isMobile ? '26px' : '20px'}
                        onClick={onClick}
                        src={AckoLogoConfig.light}
                    />
                </LogoWrapper>
                <ContentWrapper>
                    <TextWrapper>
                        <TitleText>
                            Get smart insurance solutions tailor-made for your
                            business
                        </TitleText>
                        <RequestDemoButton onClick={setIsModalOpen}>
                            Request Demo
                        </RequestDemoButton>
                    </TextWrapper>
                    <BannerWrapper>
                        <Image
                            src={getImageBasePath(
                                '/images/partnershipHeader.svg'
                            )}
                            width={!isMobile ? '533px' : '700px'}
                            height={!isMobile ? '400px' : '526px'}
                        />
                    </BannerWrapper>
                </ContentWrapper>
                {isModalOpen && (
                    <RequestDemoModal
                        popupStatus={isModalOpen}
                        onClose={setIsModalOpen}
                    />
                )}
            </Container>
        </HeaderWrapper>
    );
};

export default Header;
